import { useMutation } from '@tanstack/react-query';

import { VendorSearchDto, VendorSearchResponse } from '@/api/models/vendor';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export const useSearchVendors = () => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: VendorSearchDto) => {
      // Get or create session ID for tracking
      let sessionId = sessionStorage.getItem('vendor-search-session');
      if (!sessionId) {
        sessionId = crypto.randomUUID();
        sessionStorage.setItem('vendor-search-session', sessionId);
      }

      // Since the endpoint is public, we can pass null for session if not authenticated
      // But we'll still use session if available for consistency
      return handleApiCall<VendorSearchResponse, VendorSearchDto>(
        session,
        'POST',
        'vendor/search',
        data,
        {
          headers: {
            'x-session-id': sessionId,
          },
        }
      );
    },
    retry: 1, // Retry once on failure
    retryDelay: 1000, // Wait 1 second before retry
  });
};